import React from 'react';
import { styled } from '@linaria/react';
import { toggle } from 'opticks';
import { Grid } from '@daedalus/atlas/helpers/Grid';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
interface ChargeLaterLabelPropsType {
  /** Defines where the label is used */
  variant?: 'default' | 'roomSelection';
}
const _exp = /*#__PURE__*/() => Icon;
const StyledIcon = /*#__PURE__*/styled(_exp())({
  name: "StyledIcon",
  class: "s1yizydk",
  propsAsIs: true
});
export const ChargeLaterLabel = ({
  variant = 'default'
}: ChargeLaterLabelPropsType) => {
  const textColor = variant === 'roomSelection' ? 'content.featured.c600' : 'content.neutral.c950';
  const iconColor = variant === 'roomSelection' ? 'content.featured.c600' : 'content.neutral.c600';
  const iconSize = variant === 'roomSelection' ? 'md' : 'sm';
  return <Grid container alignItems="center" wrap="nowrap" spacing="s200" gap="s100">
      <Grid mobileSm="fit">
        <StyledIcon name="Clock" colorPath={iconColor} size={iconSize} />
      </Grid>
      <Grid mobileSm="fill">
        <Text variant="bodyS" colorPath={textColor}>
          {toggle('50feb427-cl-differential-price', <FormattedMessageWrapper id="payment.payLater" defaultMessage="Book now, pay later" />, <FormattedMessageWrapper id="chargeLater.label" defaultMessage="Pay now or later" />)}
        </Text>
      </Grid>
    </Grid>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");